import { useState } from "react";
import Select from "react-select";
import countries from "world-countries";

import UploadFile from "../../../../components/UploadFile";

import SocialField from "../../../../components/SocialField";

import telegramIcon from "../../../../assets/telegram-i.svg";
import xIcon from "../../../../assets/x-icon-img.svg";
import facebookIcon from "../../../../assets/facebook-img.svg";
import youtubeIcon from "../../../../assets/youtube-img.svg";
import linkedinIcon from "../../../../assets/linkedin-img.svg";

export default function EditProfileGeneral({
  details,
  handleInput,
  handleFileChange,
  handleCountryChange,
}) {
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [fileName, setFileName] = useState("Upload");

  const countryOptions = countries.map((country) => ({
    value: country.name.common, //
    label: country.name.common,
  }));

  const handleCountry = (selected) => {
    setSelectedCountry(selected);
    handleCountryChange(selected.value);
  };

  return (
    <>
      <div className="general-edit-wrapper-parent">
        <UploadFile handleFileChange={handleFileChange} />
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            name="name"
            value={details.name}
            onChange={handleInput}
            maxLength="25"
          />
        </div>

        <div className="form-group">
          <label>Current Role</label>
          <input
            type="text"
            name="current_role"
            value={details.profile.current_role}
            onChange={handleInput}
            maxLength="25"
          />
        </div>

        <div className="form-group bio-textarea">
          <label>Description</label>
          <textarea
            type="text"
            name="bio"
            value={details.profile.bio}
            onChange={handleInput}
            maxLength="320"
          ></textarea>
        </div>

        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            name="email"
            value={details.email}
            onChange={handleInput}
          />
        </div>

        <div className="form-group">
          <label>Contact Phone</label>
          <input
            type="tel"
            name="phone"
            maxLength={20}
            value={details.profile.phone}
            onChange={handleInput}
          />
        </div>

        <div className="form-group form-group-country-select">
          <label>Country</label>
          <Select
            options={countryOptions}
            name="country"
            value={
              countryOptions.find(
                (option) => option.value === details.profile.country
              ) || selectedCountry
            }
            onChange={handleCountry}
            placeholder="Select a country"
            isSearchable
          />
        </div>

        <div className="profil-edit-social-wrapper">
          <div className="separator"></div>
          <span>Social</span>

          <SocialField
            icon={linkedinIcon}
            value={details.profile.linkedin}
            handleInput={handleInput}
            alt="linkedin"
            name="linkedin"
            placeholder="https://linkedin.com/"
          />
          <SocialField
            icon={telegramIcon}
            value={details.profile.telegram}
            handleInput={handleInput}
            alt="telegram"
            name="telegram"
            placeholder="https://telegram.org/"
          />
          <SocialField
            icon={xIcon}
            value={details.profile.twitter}
            handleInput={handleInput}
            alt="twitter"
            name="twitter"
            placeholder="https://x.com/"
          />
          <SocialField
            icon={facebookIcon}
            value={details.profile.facebook}
            handleInput={handleInput}
            alt="facebook"
            name="facebook"
            placeholder="https://facebook.com/"
          />
          <SocialField
            icon={youtubeIcon}
            value={details.profile.youtube}
            handleInput={handleInput}
            alt="youtube"
            name="youtube"
            placeholder="https://youtube.com/"
          />
        </div>
      </div>
    </>
  );
}
